import { VaccinationAct as ProVaccinationAct } from "@syadem/kairos-pro-js";
import { VaccinationAct as TeamVaccinationAct } from "@syadem/kairos-team-js";

export type DomainVaccinationAct = ProVaccinationAct & TeamVaccinationAct;

export interface Certificate {
  certificator: {
    id: string;
    type: "professional" | "team";
    teamMemberAccountId?: string;
  };
  certifiedOn: Date;
  certificationMethod: "execution" | "proof" | "not_validated";
}

export const printableDiseasesGroups = [
  [
    1, // "Diphtérie"
    2, // "Tétanos"
    4  // "Poliomyélite"
  ],
  [
    1, // "Diphtérie"
    2, // "Tétanos"
    3, // "Coqueluche"
    4  // "Poliomyélite"
  ],
  [
    1, // "Diphtérie"
    2, // "Tétanos"
    3  // "Coqueluche"
  ],
  [
    1, // "Diphtérie"
    2, // "Tétanos"
    3, // "Coqueluche"
    4, // "Poliomyélite"
    5  // "Haemophilus influenzae b"
  ],
  [
    1, // "Diphtérie"
    2, // "Tétanos"
    3, // "Coqueluche"
    4, // "Poliomyélite"
    5, // "Haemophilus influenzae b"
    6  // "Hépatite B"
  ],
  [
    8, // "Rougeole"
    9, // "Oreillons"
    10 // "Rubéole"
  ],
  [
    16, // "Hépatite A"
    6   // "Hépatite B"
  ],
  [
    44, // "Méningocoque A"
    43, // "Méningocoque C"
    46, // "Méningocoque W"
    47  // "Méningocoque Y"
  ],
  [
    16, // "Hépatite A"
    18  // "Typhoïde"
  ]
]

export function getCertificate(vaccinationAct: DomainVaccinationAct): Certificate | null {
  if (!(vaccinationAct.certificator && vaccinationAct.certificationMethod && vaccinationAct.certifiedOn)) {
    return null;
  }

  return {
    certificator: {
      id: vaccinationAct.certificator.id,
      type: vaccinationAct.certificator.type,
      teamMemberAccountId: vaccinationAct.certificator.teamMemberAccountId ?? undefined,
    },
    certificationMethod: vaccinationAct.certificationMethod,
    certifiedOn: vaccinationAct.certifiedOn,
  };
}
